export default __webpack_public_path__ + "static/media/diagram-en.12b26c95.png";